const bootstrapGrowl = (message, args = {}) => {
  $.bootstrapGrowl(message, {
    ele: 'body',
    type: 'success',
    delay: 5 * 1000,
    ...args,
    offset: { from: 'top', amount: 55 },
    stackup_spacing: 10 // spacing between consecutively stacked growls.
  });
};

export default bootstrapGrowl;
